<template>
  <DeleteExpenseModal />
  <CreateExpenseModal />
  <UpdateExpenseModal />
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing radius-7">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 radius-7"
    >
      <span class="text-muted fs-13 mb-10 d-block">Despesas · Dados gerais da empresa</span>
      <div class="d-sm-flex align-items-center">
        <a
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#CreateExpenseModal"
        >
          Lançar nova despesa
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </a>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25 mt-10">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Despesa
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Valor
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Tipo
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Editar
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Deletar
              </th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="(value, key) in getExpenseData" :key="key">

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.expense }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.value }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ value.recurrence == 1 ? 'Recorrente' : value.recurrence_date }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentExpense(value)" data-bs-toggle="modal" data-bs-target="#UpdateExpenseModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-edit lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <button v-on:click="setCurrentDeleteExpense(value)" data-bs-toggle="modal" data-bs-target="#DeleteExpenseModal" class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button">
                  <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                </button>
              </td>

            </tr>
          
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

import DeleteExpenseModal from './DeleteExpenseModal.vue';
import CreateExpenseModal from './CreateExpenseModal.vue';
import UpdateExpenseModal from './UpdateExpenseModal.vue';

export default defineComponent({
  name: "GoalsList",
  computed: {
    ...mapGetters([
      'getExpenseData'
    ])
  },
  components: {
    DeleteExpenseModal,
    CreateExpenseModal,
    UpdateExpenseModal
  },
  methods: {
    ...mapActions([
      "setCurrentExpense",
      "setCurrentDeleteExpense",
      "setCurrentDeleteClient",
      "setCurrentUpdateClient"
    ])
  }
});
</script>
